import React, { useState } from "react";
import { Link } from "react-router-dom";

function ReturnOrder() {
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const generatedOrder = `#${Math.floor(10000 + Math.random() * 90000)}`;

  const returnReasons = [
    "Printer not working on arrival",
    "Ink/Toner leaked during delivery",
    "Printer not compatible with my device",
    "Wrong product delivered",
    "Print quality issues",
    "Item damaged or broken",
    "Missing parts or cables",
    "Ordered by mistake",
  ];

  const sampleItem = {
    name: "HP DeskJet 4155e Wireless All-in-One Printer",
    quantity: 1,
    price: 129.99,
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 300);
  };

  return (
    <div className="return-new-wrapper">
      <div className="container">
        <h2 className="page-title">Return Request</h2>

        {/* STEP 1 — ENTER ORDER NUMBER */}
        {!showForm && !submitted && (
          <div className="card-box fadeIn">
            <p className="info-text">
              Enter your order number to start a return request.
            </p>

            <input className="input-box" placeholder="#12345" />

            <button className="btn-primary" onClick={() => setShowForm(true)}>
              Continue
            </button>

            <Link to="/shop" className="back-link">
              ← Back to Shopping
            </Link>
          </div>
        )}

        {/* STEP 2 — RETURN FORM */}
        {showForm && !submitted && (
          <div className="card-box fadeIn">
            <h4 className="section-title">Order Found</h4>
            <div className="order-tag">{generatedOrder}</div>

            <div className="details-section">
              <p className="sub-label">Product</p>
              <div className="product-name">{sampleItem.name}</div>

              <div className="row-line">
                <span>Quantity</span>
                <strong>{sampleItem.quantity}</strong>
              </div>

              <div className="row-line">
                <span>Price</span>
                <strong>${sampleItem.price}</strong>
              </div>

              <div className="divider" />

              <label className="sub-label">Select Return Reason</label>
              <select className="input-box">
                {returnReasons.map((r, i) => (
                  <option key={i}>{r}</option>
                ))}
              </select>

              <textarea
                className="input-box"
                rows={3}
                placeholder="Additional comments (optional)"
              />

              <button className="btn-primary full" onClick={handleSubmit}>
                Submit Return Request
              </button>
            </div>

            <Link className="back-link" to="/shop">
              Cancel & Continue Shopping
            </Link>
          </div>
        )}

        {/* STEP 3 — SUCCESS MESSAGE */}
        {submitted && (
          <div className="success-wrapper fadeIn">
            <div className="success-icon">✓</div>

            <h3 className="success-title">Return Request Submitted</h3>

            <p className="success-text">
              Your request for <strong>{generatedOrder}</strong> has been
              received. Our team will contact you within 24–48 hours with the
              next steps.
            </p>

            <div className="btn-row">
              <Link to="/my-account" className="btn-primary">
                Go to My Account
              </Link>

              <Link to="/shop" className="btn-outline">
                Continue Shopping
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* ======= STYLING ======= */}
      <style>{`
        .return-new-wrapper {
          padding: 70px 0;
          background: #f4f7fb;
        }

        .page-title {
          text-align: center;
          font-size: 34px;
          font-weight: 700;
          margin-bottom: 30px;
        }

        .card-box {
          background: #fff;
          padding: 28px;
          border-radius: 16px;
          max-width: 500px;
          margin: auto;
          box-shadow: 0 12px 25px rgba(0,0,0,0.07);
          animation: fadeUp .4s ease;
        }

        .info-text {
          color: #555;
          margin-bottom: 15px;
        }

        .input-box {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd8e3;
          font-size: 16px;
          margin-bottom: 15px;
          transition: .2s;
        }

        .input-box:focus {
          border-color: #0b61d6;
          box-shadow: 0 0 0 2px rgba(11,97,214,0.15);
        }

        .btn-primary {
          background: #0b61d6;
          padding: 14px 20px;
          color: white;
          font-weight: 600;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          text-decoration: none;
          transition: .3s;
          display: inline-block;
        }

        .btn-primary:hover {
          background: #094bb2;
        }

        .btn-outline {
          padding: 14px 20px;
          border-radius: 10px;
          border: 2px solid #0b61d6;
          color: #0b61d6;
          font-weight: 600;
          text-decoration: none;
          transition: .3s;
        }

        .btn-outline:hover {
          background: #0b61d6;
          color: white;
        }

        .full { width: 100%; }

        .back-link {
          display: block;
          margin-top: 12px;
          font-size: 14px;
          color: #0b61d6;
          text-decoration: none;
        }

        .order-tag {
          display: inline-block;
          padding: 8px 18px;
          background: #e7f1ff;
          border-radius: 12px;
          color: #0b61d6;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 18px;
        }

        .details-section {
          text-align: left;
        }

        .product-name {
          font-weight: 600;
          margin-bottom: 10px;
        }

        .sub-label {
          margin: 10px 0 6px;
          font-weight: 600;
        }

        .row-line {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
          font-size: 16px;
        }

        .divider {
          border-bottom: 1px solid #ddd;
          margin: 14px 0;
        }

        /* SUCCESS AREA */
        .success-wrapper {
          text-align: center;
          padding: 30px;
          max-width: 520px;
          margin: auto;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 12px 25px rgba(0,0,0,0.07);
        }

        .success-icon {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: #31c653;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 48px;
          margin: 0 auto 18px;
          animation: pop .35s ease;
        }

        .success-title {
          font-size: 26px;
          font-weight: 700;
        }

        .success-text {
          color: #555;
          margin: 10px 0 25px;
          line-height: 1.6;
        }

        .btn-row {
          display: flex;
          justify-content: center;
          gap: 14px;
        }

        /* Animations */
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pop {
          0% { transform: scale(0.3); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }

        .fadeIn {
          animation: fadeUp .4s ease;
        }
      `}</style>
    </div>
  );
}

export default ReturnOrder;
